import { storyClasses } from "@/pages/app/storyClasses";

export const printStyles = `
  @media print {
    * {
      background: transparent !important;
      border: none !important;
      outline: none !important;
    }

    @page {
      size: A4 landscape;
      margin: 15mm;
    }

    /* Hide UI elements */
    a,
    button,
    footer,
    header,
    hr,
    nav,
    svg,
    .MuiAppBar-root,
    .MuiAvatar-root,
    .MuiBadge-root,
    .MuiBottomNavigation-root,
    .MuiBottomNavigationAction-root,
    .MuiButton-root,
    .MuiButtonBase-root,
    .MuiDivider-root,
    .MuiFab-root,
    .MuiGrid-root,
    .MuiIconButton-root,
    .MuiToolbar-root {
      display: none !important;
    }

    /* Reset root containers for print */
    html,
    body {
      margin: 0 !important;
      padding: 0 !important;
      height: auto !important;
      min-height: 0 !important;
      overflow: visible !important;
      background: #fff !important;
    }

    body {
      font-family: -apple-system, sans-serif;
      font-size: 10pt;
      line-height: 1.6;
      color: #000;
    }

    #root {
      height: auto !important;
      min-height: 0 !important;
      position: static !important;
    }

    /* Force containers to collapse */
    .MuiContainer-root,
    .MuiBox-root,
    .MuiStack-root {
      display: block !important;
      position: static !important;
      margin: 0 !important;
      padding: 0 !important;
      height: auto !important;
      min-height: 0 !important;
      max-height: none !important;
      width: 100% !important;
      max-width: 100% !important;
      overflow: visible !important;
    }

    /* Override inline styles */
    [style] {
      position: static !important;
      overflow: visible !important;
      height: auto !important;
      inset: auto !important;
    }

    /* Story title */
    h1 {
      display: block !important;
      visibility: visible !important;
      margin: 2em 0 3em 0 !important;
      padding: 0 !important;
      font-size: 16pt !important;
      font-weight: bold !important;
      color: #000 !important;
    }

    /* Story text in columns */
    .${storyClasses.content} {
      column-count: 2 !important;
      column-gap: 4em !important;
      display: block !important;
      margin: 0 !important;
      padding: 0 !important;
      text-align: justify !important;
      text-indent: 1.5em !important;
      visibility: visible !important;
    }

    .${storyClasses.content}, .${storyClasses.content} * {
      background: none !important;
      color: #000 !important;
      color: #000 !important;
      font-size: 10pt !important;
      line-height: 1.6 !important;
      white-space: normal !important;
      word-break: normal !important;
    }

    /* Ensure all text is black */
    *,
    *::before,
    *::after {
      color: #000 !important;
    }
  }
  `;
